import { PdSample, PdResult } from './types'

export const fmt = (n: number | undefined | null, d = 1) => n?.toFixed(d) ?? '—'

export const fmtVec = (v: { x: number; y: number; z: number }) =>
  `x: ${fmt(v.x)}  y: ${fmt(v.y)}  z: ${fmt(v.z)}`

export function pdVariance(buf: number[]): number {
  if (buf.length < 2) return 999
  const mean = buf.reduce((a, b) => a + b, 0) / buf.length
  return buf.reduce((a, b) => a + (b - mean) ** 2, 0) / buf.length
}

export function averagePd(samples: PdSample[]): PdResult {
  const n = samples.length
  return {
    pd: samples.reduce((a, s) => a + s.pd, 0) / n,
    leftPd: samples.reduce((a, s) => a + s.leftPd, 0) / n,
    rightPd: samples.reduce((a, s) => a + s.rightPd, 0) / n,
    nearPd: samples.reduce((a, s) => a + s.nearPd, 0) / n,
    nearLeftPd: samples.reduce((a, s) => a + s.nearLeftPd, 0) / n,
    nearRightPd: samples.reduce((a, s) => a + s.nearRightPd, 0) / n,
  }
}
